(function(){
  // prova a ricavare il section.id dal <template>
  var tpl = document.querySelector('[id^="variant-external-size-map-"]');
  if(!tpl) return;
  var secId = tpl.id.replace('variant-external-size-map-','');

  // leggi mappa variantId -> misura
  var json = tpl.innerHTML || tpl.textContent || '{}';
  var sizeMap = {};
  try { sizeMap = JSON.parse(json); } catch(e) {}

  var rowEl   = document.getElementById('external-size-row-' + secId);
  var valueEl = document.getElementById('external-size-value-' + secId);
  if(!rowEl || !valueEl) return;

  function setSize(variantId){
    var val = sizeMap[String(variantId)] || '';
    if(!val || String(val).trim() === ''){
      rowEl.style.display = 'none';
    } else {
      rowEl.style.display = '';
      valueEl.textContent = val;
    }
  }

  // 1) evento nativo dei temi moderni (Split/Dawn)
  document.addEventListener('variant:change', function(e){
    var v = e.detail && e.detail.variant;
    if(v && v.id) setSize(v.id);
  });

  // 2) fallback: ascolta cambi nel form varianti
  var form = document.querySelector('form[action*="/cart/add"]');
  if(form){
    form.addEventListener('change', function(){
      var idInput = form.querySelector('input[name="id"]');
      var select  = form.querySelector('select[name="id"]');
      var variantId = (idInput && idInput.value) || (select && select.value);
      if(variantId) setSize(variantId);
    });

    // alcuni temi sostituiscono l’input id dinamicamente
    new MutationObserver(function(){
      var idInput = form.querySelector('input[name="id"]');
      if(idInput && idInput.value) setSize(idInput.value);
    }).observe(form, {subtree:true, childList:true});
  }

  // 3) init con la variante corrente
  // tenta dal form, altrimenti usa la prima chiave della mappa
  (function(){
    var initialId = null;
    if(form){
      var idInput = form.querySelector('input[name="id"]');
      var select  = form.querySelector('select[name="id"]');
      initialId = (idInput && idInput.value) || (select && select.value);
    }
    if(!initialId){
      var keys = Object.keys(sizeMap);
      if(keys.length) initialId = keys[0];
    }
    if(initialId) setSize(initialId);
  })();
})();